import type { AddOnDto } from "../../api/hooks/useAddOns";
import type { BillingCycle } from "../../api/hooks/useTradingStrategies";

/** The cycles an add-on is sold on: only those it has a price for, so it can be one. */
export function addOnCycles(addOn: AddOnDto): BillingCycle[] {
  const cycles: BillingCycle[] = [];
  if (addOn.monthlyPriceUsd !== null) cycles.push("Monthly");
  if (addOn.yearlyPriceUsd !== null) cycles.push("Yearly");
  return cycles;
}

export function addOnPrice(addOn: AddOnDto, cycle: BillingCycle): number {
  return (cycle === "Yearly" ? addOn.yearlyPriceUsd : addOn.monthlyPriceUsd) ?? 0;
}
